import React, { useEffect } from "react";
import {
  Form,
  Input,
  Modal,
  Select,
  Switch,
  InputNumber,
  Row,
  Col,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { addBrand, getBrands } from "../../store/actions/brand";
import SearchableSelectWithAdd from "../../components/SearchableSelectWithAdd";
import BrandsForm from "../Brands/BrandsForm";

const SeriesForm = ({ visible, onCreate, onCancel, record, initialValues }) => {
  // ← added initialValues
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const brandList = useSelector((state) => state.brand.list);

  // Fetch brands on mount
  useEffect(() => {
    dispatch(getBrands());
  }, [dispatch]);

  // Populate form when editing, reset when adding
  useEffect(() => {
    if (visible) {
      // ← added visible check
      if (record?.id) {
        // EDIT mode — fill all fields from record
        form.setFieldsValue({
          name: record.name,
          brandId: record.brandid,
          ordinal: record.ordinal,
          isForAll: record.isForAll ?? false,
        });
      } else {
        // ADD mode — reset first, then pre-fill if initialValues exists
        form.resetFields();
        if (initialValues) {
          form.setFieldsValue(initialValues); // ← pre-fills name from search
        }
      }
    }
  }, [visible, record, form, initialValues]); // ← added visible & initialValues

  // Submit
  const handleOk = async () => {
    // ← made async
    const values = await form.validateFields();
    await onCreate(values);
    form.resetFields(); // ← added reset after submit
  };

  // const handleOk = () => {
  //   form
  //     .validateFields()
  //     .then((values) => {
  //       onCreate(values);
  //     })
  //     .catch(() => { });
  // };

  // Cancel
  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      open={visible}
      title={record ? "Edit Series" : "Add Series"}
      okText={record ? "Update" : "Create"}
      cancelText="Cancel"
      onCancel={handleCancel}
      onOk={handleOk}
      destroyOnClose
      zIndex={99999} // ← changed from 9999 to 99999
    >
      <Form
        form={form}
        layout="vertical"
        name="seriesForm_modal"
        validateTrigger={["onSubmit", "onChange"]}
        initialValues={{ isForAll: true }}
      >
        {/* Brand */}
        <Form.Item
          name="brandId"
          label="Brand"
          rules={[{ required: true, message: "Please select a brand!" }]}
        >
          <SearchableSelectWithAdd
            placeholder="Select Brand"
            style={{ width: "100%" }}
            options={brandList}
            valueKey="id"
            labelKey="name"
            FormComponent={BrandsForm}
            onFormCreate={async (values) => {
              const payload = {
                name: values.name,
                isForAll: values.isForAll ?? false,
                ...(values.ordinal !== undefined &&
                  values.ordinal !== null && {
                    ordinal: Number(values.ordinal),
                  }),
              };
              const created = await dispatch(addBrand(payload, false));
              if (created) {
                await dispatch(getBrands());
                return created;
              }
            }}
          />
        </Form.Item>

        {/* Name */}
        <Form.Item
          name="name"
          label="Series Name"
          rules={[
            { required: true, message: "Name is required" },
            { type: "string", message: "Name should be a string" },
          ]}
        >
          <Input
            placeholder="Enter series name"
            onChange={(e) => {
              const val = e.target.value;
              if (val) {
                form.setFieldValue(
                  "name",
                  val.charAt(0).toUpperCase() + val.slice(1),
                );
              }
            }}
          />
        </Form.Item>

        <Row gutter={16}>
          {/* Ordinal */}
          <Col span={12}>
            <Form.Item
              name="ordinal"
              label="Ordinal"
              rules={[
                { type: "number", message: "Ordinal should be a number" },
              ]}
            >
              <InputNumber
                placeholder="e.g. 1"
                style={{ width: "100%" }}
                min={0}
              />
            </Form.Item>
          </Col>

          {/* isForAll — only on Add */}
          {!record && (
            <Col span={12}>
              <Form.Item
                name="isForAll"
                label="Add For All"
                valuePropName="checked"
                initialValue={false}
              >
                <Switch checkedChildren="Yes" unCheckedChildren="No" />
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );
};

export default SeriesForm;
